var AdminModule = {
    CaseCityChart: function () { return import('./case-city-chart.vue'); },
    CaseGroupChart: function () { return import('./case-group-chart.vue'); },
    CaseRecordChart: function () { return import('./case-record-chart.vue'); },
    CaseRepayChart: function () { return import('./case-repay-chart.vue'); },
    InnerRankList: function () { return import('./inner-rank-list.vue'); },
    OuterRankList: function () { return import('./outer-rank-list.vue'); },
    CaseOverviewComponent: function () { return import('./case-overview-component.vue'); },
    SystemNotice: function () { return import('./system-notice.vue'); },
    WaitCaseChart: function () { return import('./wait-case-chart.vue'); }
};
export default AdminModule;
